import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';
@Component({
  selector: 'fgb-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss'],
})
export class FaqPageComponent implements OnInit {
  disabled = false;
  
  constructor(
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.navigationService.hideMobileNav();
  }
  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
